import { SubscriptionProduct } from '../core/models/module';

export const isSpouseProduct = (product?: SubscriptionProduct): boolean => {
	return !!product && product.attributes.tags.some((t) => t.urlSafe.includes('spouse'));
};
